import React from 'react';
import { PRODUCTS } from '../../../constants/ProductsLight';
import Strings from '../../../i18n';
import { ICommandOnOff } from '../../../types/commandsInterface';

interface SelectProductModalProps {
  show: boolean;
  onHide: () => void;
  name: string;
  idChannel: number;
  lightId: number;
  deviceId: string;
  sendCommand: (payload: ICommandOnOff) => void;
  handleSetProductType: (
    configurationId: number,
    productType: number,
    deviceId: string
  ) => void;
}

export const SelectProductModal: React.FC<SelectProductModalProps> = ({
  show,
  onHide,
  name,
  idChannel,
  lightId,
  deviceId,
  sendCommand,
  handleSetProductType
}) => {
  const handleSelectedProduct = (idProductType: number) => {
    if (idProductType === PRODUCTS[0].id) {
      sendCommand({
        id: lightId,
        method: 'Off',
        type: 'Light'
      });
    }
    handleSetProductType(lightId, idProductType, deviceId);
    onHide();
  };

  return (
    <div
      className={`modal fade ${show ? 'show d-block' : ''}`}
      tabIndex={-1}
      role="dialog"
      style={{ background: show ? 'rgba(0,0,0,0.5)' : 'transparent' }}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{Strings.groups.xSeriesSetup}</h5>
          </div>
          <div className="modal-body">
            <p>{Strings.groups.selectProduct.productConnected(name)}</p>
            <p>{Strings.groups.selectProduct.colorChannel('RED')}</p>
            <ul className="list-group">
              {PRODUCTS.map((item) => (
                <li
                  key={item.id}
                  className="list-group-item d-flex justify-content-between align-items-center"
                  style={{ marginBottom: 10 }}
                >
                  {item.name}
                  <button
                    type="button"
                    className="btn btn-primary btn-sm rounded-pill"
                    onClick={() => handleSelectedProduct(item.id)}
                  >
                    Seleccionar
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onHide}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
